<template>
  <div id="order-split-form" class="mt-3">
    <div class="order-split-form-description mb-5">
      <span class="mr-2">{{ $t('views.orders.orderModal.split.description') }}</span>
      <InfoIcon :text="$t('views.orders.orderModal.split.help')" />
    </div>
    <div class="order-split-form-flex mt-4">
      <div class="order-split-form-flex-dividend">
        <v-text-field
          v-model="dividend"
          type="number"
          :disabled="loading || !isSplit"
          hide-details
          dense
          outlined
        />
      </div>
      <div class="order-split-form-flex-colon">
        <p>:</p>
      </div>
      <div class="order-split-form-flex-divisor">
        <v-text-field
          v-model="divisor"
          type="number"
          :disabled="loading || isSplit"
          hide-details
          dense
          outlined
        />
      </div>
      <div class="order-split-form-flex-rotate">
        <v-tooltip top>
          <template v-slot:activator="{ on: on, attrs: attrs }">
            <v-icon size="30" v-bind="attrs" @click="rotateInput" v-on="on">
              mdi-swap-horizontal-bold
            </v-icon>
          </template>
          <span>
            {{
              isSplit
                ? $t('views.orders.orderModal.split.rotateToReverseSplit')
                : $t('views.orders.orderModal.split.rotateToSplit')
            }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <div v-if="divisor && divisor > 1" class="mt-6">
      <base-material-alert color="primary" icon="mdi-alert">
        {{ $t('views.orders.orderModal.split.notIntegerWarning1') }}{{ divisor
        }}{{ $t('views.orders.orderModal.split.notIntegerWarning2') }}
      </base-material-alert>
    </div>
  </div>
</template>

<script>
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: { InfoIcon },
  props: {
    positionNumber: {
      type: Number,
      default: null,
    },
    price: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dividend: null,
      divisor: 1,
      isSplit: true,
    }
  },
  watch: {
    dividend: {
      handler() {
        if (this.dividend < 0) this.dividend = 1
        this.updateAndEmit()
      },
    },
    divisor: {
      handler() {
        if (this.divisor < 0) this.divisor = 1
        this.updateAndEmit()
      },
    },
    price: {
      handler() {
        if (!this.price || !this.positionNumber) return
        if (this.price === 1 && this.positionNumber === 1) return
        if (this.positionNumber < 1) {
          this.dividend = 1
          this.divisor = this.price
          this.isSplit = false
        } else {
          this.divisor = 1
          this.dividend = this.positionNumber
          this.isSplit = true
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateAndEmit() {
      const positionNumber = this.dividend / this.divisor
      const price = 1 / positionNumber
      this.$emit('update:positionNumber', positionNumber)
      this.$emit('update:price', price)
    },
    rotateInput() {
      if (this.loading) return

      if (!this.isSplit) {
        this.dividend = this.divisor
        this.divisor = 1
        this.isSplit = true
      } else {
        this.divisor = this.dividend
        this.dividend = 1
        this.isSplit = false
      }
    },
  },
}
</script>

<style lang="scss">
#order-split-form {
  .order-split-form-description {
    font-size: 14px;
    text-align: justify;
  }
  .order-split-form-flex {
    display: flex;
    align-items: center;
    .order-split-form-flex-rotate {
      padding-left: 15px;
    }
    input {
      font-size: 20px;
    }
    .order-split-form-flex-colon {
      font-size: 20px;
      font-weight: bold;
      padding: 10px 30px 0 30px;
    }
  }
}
</style>
